import { render, staticRenderFns } from "./ArticlesTable.vue?vue&type=template&id=cb06fb3a&scoped=true"
import script from "./ArticlesTable.vue?vue&type=script&lang=js"
export * from "./ArticlesTable.vue?vue&type=script&lang=js"
import style0 from "./ArticlesTable.vue?vue&type=style&index=0&id=cb06fb3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb06fb3a",
  null
  
)

export default component.exports